import { userSlice } from '@wellesley/user'
import { useSelector, useDispatch } from 'react-redux'
import { useUserGroups } from '@wellesley/group'
import { useLazyGetApiV1AppsGroupByGroupIdQuery } from '@wellesley/apps'
import { useEffect } from 'react'
import {
  setActiveItem,
  ToolbarItem,
} from '../../../common/components/ToolbarItem'
import { appsListSlice } from '../AppsList/appsListSlice'
import { useActiveGroupName } from '../hooks/useActiveGroupName'
import { useLocation } from 'react-router-dom'
import { useOpenLastApp } from '../AppsList'
import AddGroupButton from '../AddGroupButton'

export const GroupsApps = () => {
  const dispatch = useDispatch()
  const user = useSelector(userSlice.selectors.selectCurrentUser)

  const activeGroupName = useActiveGroupName()
  const { userGroups, isLoading: isLoadingGroups } = useUserGroups(
    activeGroupName || '',
  )
  const [getGroupApps] = useLazyGetApiV1AppsGroupByGroupIdQuery()
  const location = useLocation()
  const { openLastApp } = useOpenLastApp()

  const getApps = async (groupName: string, groupId: string) => {
    dispatch(setActiveItem(groupName))
    const apps = await getGroupApps({ groupId }).unwrap()

    dispatch(
      appsListSlice.actions.setList({
        list: apps || [],
        entryPoint: 'GROUP',
        activeGroupName: groupName,
      }),
    )
  }

  useEffect(() => {
    if (activeGroupName && userGroups.length > 0) {
      void getApps(
        activeGroupName,
        userGroups.find((group) => group.groupName === activeGroupName)
          ?.groupId || '',
      )
    }
  }, [activeGroupName, userGroups.length, location.pathname, dispatch])

  const clickOnGroup = async (groupName: string, groupId: string) => {
    await getApps(groupName, groupId)
    openLastApp(groupName)
  }

  if (isLoadingGroups || !user) return null

  return (
    <div className="overflow-y-auto">
      {userGroups.map(({ groupId, groupName, displayName, banner }) => (
        <ToolbarItem
          key={groupId}
          id={groupName}
          name={displayName}
          Icon={banner?.files[0].uri ?? null}
          onClick={() => void clickOnGroup(groupName, groupId)}
        />
      ))}
      <AddGroupButton />
    </div>
  )
}
